module.exports = __webpack_public_path__ + "static/media/Karlsruhe11.d5fc1752.jpg";